import * as Scrivito from 'scrivito';
import { WagonSelectionItemWidgetClass } from './wagon-selection-item-widget-class';

export const WagonSelectionItemWidgetComponent: React.FC<Scrivito.WidgetComponentProps> = () => {
  return <Scrivito.WidgetTag />;
};

Scrivito.provideComponent(WagonSelectionItemWidgetClass, WagonSelectionItemWidgetComponent);
